/**
 * Role-based Dashboard Navigation Utility
 * 
 * Returns the correct dashboard route based on user roles.
 * Priority: Platform Owner > Super Admin > Admin > Host > Customer
 */

export const getDashboardRoute = (user, roleCheckers = {}) => {
  const { isPlatformOwner, isSuperAdmin, isAdmin, isHost } = roleCheckers;
  
  // Platform Owner gets highest priority
  if (isPlatformOwner?.()) {
    return '/platform-owner';
  }
  
  // Super Admin
  if (isSuperAdmin?.()) {
    return '/super-admin';
  }
  
  // Admin
  if (isAdmin?.()) {
    return '/admin';
  }
  
  // Host (non-platform-owner with host_status === 'active')
  if (isHost?.()) {
    return '/host';
  }
  
  // Default: Customer dashboard
  return '/dashboard';
};

/**
 * Navigate to the appropriate dashboard based on user role
 * @param {Function} navigate - React Router navigate function
 * @param {Object} roleCheckers - Object containing role checking functions
 */
export const navigateToDashboard = (navigate, roleCheckers) => {
  const route = getDashboardRoute(null, roleCheckers);
  navigate(route);
};
